import { isStringArray } from "@/utils/typeGuards";
import { conflictDetailOf, isRecord } from "../conflictDetail";

/** i18n key the location delete raises with a 409 when staff are credentialed for a row being removed. */
export const HAS_CREDENTIALS_KEY = "locations.delete.hasCredentials";

/**
 * The rows a refused delete was blocked on, read from the 409 `locations.delete.hasCredentials` body
 * (`detail.details.rowIds`). Reads a wrapping `Error`'s `cause` when the error itself isn't the response.
 *
 * Returns null for any other error, so it keeps its snackbar path. The backend raises this key only
 * after finding credentialed rows and always names them, so a missing, empty or malformed `rowIds` is a
 * broken contract and throws instead of being shown as a generic refusal.
 */
export function credentialRowIdsFromError(error: unknown): string[] | null {
	const detail = conflictDetailOf(error);
	if (detail === null || detail.message !== HAS_CREDENTIALS_KEY) return null;

	const rowIds = isRecord(detail.details) ? detail.details.rowIds : undefined;
	if (!isStringArray(rowIds) || rowIds.length === 0) {
		throw new Error(`credentialRowIdsFromError: a 409 ${HAS_CREDENTIALS_KEY} carried malformed details.rowIds`, { cause: error });
	}
	return rowIds;
}
